var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#fff",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M5.244 7.12v-.25q0-.294.068-.512.067-.219.226-.41.16-.195.43-.405.278-.218.44-.377.167-.159.239-.318a.9.9 0 0 0 .075-.378q0-.338-.23-.512-.226-.18-.64-.18-.366 0-.687.104a5 5 0 0 0-.636.258l-.33-.699q.361-.198.783-.318Q5.407 3 5.916 3q.81 0 1.251.393.445.394.445 1.037 0 .354-.11.608a1.5 1.5 0 0 1-.33.465q-.216.21-.521.445a3.4 3.4 0 0 0-.386.346.9.9 0 0 0-.182.29 1.2 1.2 0 0 0-.048.354v.183zm-.15 1.28q0-.326.166-.457a.65.65 0 0 1 .417-.135.64.64 0 0 1 .41.135q.17.131.17.457 0 .319-.17.46a.63.63 0 0 1-.41.14.64.64 0 0 1-.417-.14q-.167-.141-.167-.46"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };